import React, { useEffect, useRef, useState, useCallback, useMemo } from 'react';
import { Row, Col, Typography, Table, Button } from 'antd';
import { useParams } from 'react-router-dom';
import { fetchViewDieQuotationById } from '../../slices/die-quotation';
import { useDispatch, useSelector } from 'react-redux';
import { ReactComponent as PrintIcon } from '../../Images/PrintIcon.svg';
import dayjs from 'dayjs';

const PrintDiequotation = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [quotationData, setQuotationData] = useState(null);
  const { data: settingData } = useSelector(state => state.setting);
  const contentRef = useRef();

  const fetchData = useCallback(async () => {
    try {
      const response = await dispatch(
        fetchViewDieQuotationById({ id }),
      ).unwrap();

      setQuotationData(response?.data);
    } catch (error) {
      console.error('Failed to fetch quotation:', error);
    }
  }, [dispatch, id]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const { Title, Text } = Typography;

  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'SrNo',
      key: 'SrNo',
      align: 'center',
      width: '6%',
      className: 'col-sr',
      render: (text, object, index) => {
        return index + 1;
      },
    },
    {
      title: 'Inq No.',
      dataIndex: 'inquiry_number',
      key: 'inquiry_number',
      align: 'center',
      width: '8%',
      className: 'col-inq',
      render: (text, record) => {
        return (
          <span>{record?.inquiry_number ? record?.inquiry_number : 'N/A'}</span>
        );
      },
    },
    {
      title: 'Profile No.',
      dataIndex: 'die_number',
      key: 'die_number',
      align: 'center',
      width: '8%',
      className: 'col-profile',
      render: (text, record) => {
        return (
          <span>
            {record?.profile_no?.die_number
              ? record?.profile_no?.die_number
              : 'N/A'}
          </span>
        );
      },
    },
    {
      title: 'Description',
      dataIndex: 'die_die_quotation_details',
      key: 'die_die_quotation_details',
      align: 'center',
      width: '12%',
      className: 'col-desc',
      render: (text, record) => {
        const dimensions = [
          record?.profile_no?.dimension1,
          record?.profile_no?.dimension2,
          record?.profile_no?.dimension3,
          record?.profile_no?.dimension4,
        ]
          .filter(dim => dim !== null && dim !== '' && dim !== undefined && dim !== '0.00')
          .map(dim => Number(dim)?.toFixed(2));

        if (dimensions.length === 0) return <span>N/A</span>;
        return (
          <div>
            {dimensions.join(' X ')}
          </div>
        );
      },
    },
    {
      title: 'Alloy',
      dataIndex: 'alloy',
      key: 'alloy',
      align: 'center',
      width: '8%',
      className: 'col-alloy',
      render: record => {
        return <span>{record?.alloy_code || 'N/A'}</span>;
      },
    },
    {
      title: 'Press Cap.',
      dataIndex: 'press_capacity',
      key: 'press_capacity',
      align: 'center',
      width: '8%',
      className: 'col-press',
    },
    {
      title: 'UoM',
      dataIndex: 'unit_of_measurement',
      key: 'unit_of_measurement',
      align: 'center',
      width: '6%',
      className: 'col-uom',
    },
    {
      title: 'Qty',
      dataIndex: 'quantity',
      key: 'quantity',
      align: 'center',
      width: '6%',
      className: 'col-qty',
    },
    {
      title: 'Basic',
      dataIndex: 'profile_devlopment_cost',
      key: 'profile_devlopment_cost',
      align: 'right',
      width: '9%',
      className: 'col-basic',
      render: (value) => {
        return value ? value?.toFixed(2) : '0.00';
      },
    },
    {
      title: 'IGST',
      key: 'cgst',
      align: 'right',
      width: '8%',
      className: 'col-igst',
      render: record => {
        const cgst = record?.profile_devlopment_cost
          ? (record.profile_devlopment_cost * 18) / 100
          : 0;
        return <span>{cgst?.toFixed(2)}</span>;
      },
    },
    {
      title: 'Total (Rs.)',
      key: 'total',
      align: 'right',
      width: '10%',
      className: 'col-total',
      render: record => {
        const basicAmount = record?.profile_devlopment_cost || 0;
        const sgst = (basicAmount * 9) / 100;
        const cgst = (basicAmount * 9) / 100;
        const totalAmount = basicAmount + sgst + cgst;
        return <span>{totalAmount?.toFixed(2)}</span>;
      },
    },
  ];

  const printStyles = `
  @media print {
  * {
    box-sizing: border-box !important;
    margin: 0 !important;
    padding: 0 !important;
    color: #000000 !important;
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji !important;
      }
  @page {
    size: A4 portrait;
    margin: 0mm;
  }

  body {
    font-size: 12px !important;
    margin: 0;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    color-adjust: exact !important;
  }

  .main-heading{
  
    font-size :14px !important ;
  }

  .print-container {
    min-height: 1000px;
    position: relative !important;
    padding-bottom: 100px !important;
     margin:10px !important;
  }

  .page {
    page-break-after: always !important;
    position: relative !important;
    box-sizing: border-box !important;
    overflow: visible !important;
  }

  .header-text {
    font-size: 12px !important;
    line-height: 1 !important;
  }

  .page-content {
    width: 100% !important;
    overflow: visible !important;
    font-size: 12px !important;

  }

  .signature-section {
     position: absolute !important;
    bottom: 10px !important;
    width: 100% !important;
    text-align: center !important;
    margin-top: 0 !important;
    page-break-inside: avoid !important;
    break-inside: avoid !important;
  }

  .bankDetails {
    font-size: 12px !important;
    margin-top: 15px !important;
    line-height: 1 !important;
  }

  .ant-row {
    display: flex !important;
    flex-wrap: wrap !important;
    margin-bottom: 15px !important;
  }

  .col-sr       { width: 2.16% !important; }  /* SR */
  .col-inq      { width: 8.33% !important; }  /* Inq No */
  .col-profile  { width: 8.33% !important; }  /* Profile No */
  .col-desc     { width: 10.33% !important; }  /* DESCRIPTION */
  .col-alloy    { width: 6.33% !important; }  /* Alloy */
  .col-press    { width: 8.33% !important; }  /* Press */
  .col-uom      { width: 6.33% !important; }  /* UoM */
  .col-qty      { width: 8.5% !important; }  /* Qty */
  .col-basic    { width: 2.5% !important; }  /* Basic */
  .col-igst     { width: 5.33% !important; }  /* CGST */
  .col-total    { width: 4.16% !important; }  /* Total */


  .ant-col {
    box-sizing: border-box;
    padding: 1px !important;
  }

  h1, h2, h3, h4, h5 {
    color: rgb(2, 15, 28) !important;
    font-size: 12px !important;
    margin-bottom: 3px !important;
    margin-top: 0 !important;
  }

  .ant-table {
    width: 100% !important;
    font-size: 12px !important;
    table-layout: fixed !important;
    margin: 8px 8px !important;
  }

  .ant-table-container {
    overflow: visible !important;
   border: 1px solid #dee2e6 !important;
    padding: 0px !important;
  }

  .ant-table-wrapper {
    padding: 0 !important;
    overflow: visible !important;
  }

  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    padding: 8px 8px !important; 
    font-size: 10px !important;
    background-color: white !important;
    border: 1px solid #dee2e6 !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    word-break: break-word !important;
    line-height: 1.1 !important;
    height: auto !important;
    min-height: 20px !important;
  }

  .kind_attention {
    margin-right: 20px !important;
  }

  .ant-table-thead > tr > th {
        background: #fff !important;
        padding:2px !important;
       
      }

  .ant-table-wrapper .ant-table-summary > tr > td {
   border: 1px solid #dee2e6 !important;
    padding: 1px 1px !important;
    font-size: 12px !important;
  }

  .summary-cell-center {
    text-align: center !important;
  }

  .summary-cell-right {
    text-align: right !important;
    padding-right: 3px !important;
  }

  .ant-divider {
    margin: 5px 0 !important;
    border: 1px solid #dee2e6 !important;
  }

  .no-print {
    display: none !important;
  }

  .terms-page {
    padding: 2px !important;
    margin: 0 !important;
    page-break-before: auto !important;
  }

  .terms-heading {
    font-size: 18px !important;
    margin-bottom: 4px !important;
  }

  .terms__content ul li{
     font-size: 10px !important;
  }

  .terms__content {
    font-size: 2px !important;
    text-align: justify !important;
    line-height: 1.2 !important;
    max-width: 100% !important;
    margin: 0 auto !important;
    padding: 0 5px !important;
  }

  .terms__content h3 {
    font-weight: 600 !important;
    margin: 5px 0 !important;
    font-size: 14px !important;
  }

  img {
    max-width: 100% !important;
  }

  .customer-details {
    margin-bottom: 8px !important;
  }

  .customer-details-header {
    background-color: #12406a !important;
    color: white !important;
    padding: 2px 5px !important;
    font-weight: bold !important;
    margin-bottom: 2px !important;
    font-size: 9px !important;
  }

  .customer-details-content {
    padding: 3px 5px !important;
  border: 1px solid #dee2e6 !important;
  }

  /* Remove horizontal scroll */
  * {
    overflow-x: visible !important;
  }

  /* Ensure table fits within page */
  .ant-table-scroll {
    overflow-x: visible !important;
  }

  /* Compact spacing */
  .ant-typography {
    margin-bottom: 0 !important;
  }

  /* Logo section */
  .logo-section img {
    max-width: 150px !important;
    height: auto !important;
    float: right !important;
  }
}
`;

  const commonStyles = `
  
 .print-container {
      // width: 800px;
      margin: 0 auto;
      padding: 10px;
      font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji !important;
    }

 .ant-table-thead > tr > th {
      background: transparent !important;
      font-weight: bold;
      padding:2rem !important;
    }
    .
`;

  const combinedStyles = useMemo(
    () => printStyles + commonStyles,
    [printStyles, commonStyles],
  );

  useEffect(() => {
    const styleEl = document.createElement('style');
    styleEl.innerHTML = combinedStyles;
    document.head.appendChild(styleEl);

    return () => {
      document.head.removeChild(styleEl);
    };
  }, [combinedStyles]);

  const handlePrint = () => {
    window.print();
  };

  return (
    <>
      <div className="print-container page" ref={contentRef} style={{ margin: '25px' }}>
        <div className="page-content">
          <Row justify="space-between" align="middle" style={{ marginBottom: '10px' }}>
            <Col span={12}>
              <div style={{ textAlign: 'left' }}>
                <Title level={4} style={{ margin: 0, color: '#12406a' }} className='main-heading'>Die Quotation</Title>
              </div>
            </Col>
            <Col span={12} className="logo-section" style={{ textAlign: 'right' }}>
              <img src={settingData?.company_settings?.company_logo} alt="Company Logo" style={{ maxWidth: '180px' }} />
            </Col>
          </Row>

          <Row gutter={[8, 8]} style={{ marginBottom: '10px' }}>
            <Col span={14}>
              <div className="customer-details">
                <div className="customer-details-header">Bill To</div>
                <div className="customer-details-content">
                  <Text className='header-text'>
                    {quotationData?.customer?.customer_name}
                    <br />
                    {quotationData?.customer?.office_address?.shop},{' '}
                    {quotationData?.customer?.office_address?.area},{' '}
                    {quotationData?.customer?.office_address?.landmark}{' '}
                    {quotationData?.customer?.office_address?.city}{' '}
                    {quotationData?.customer?.office_address?.state} -{' '}
                    {quotationData?.customer?.office_address?.pin_code}
                  </Text>
                </div>
              </div>
            </Col>

            <Col span={10}>
              <div style={{ textAlign: 'right' }}>
                <div style={{ marginBottom: '4px' }}>
                  <Text strong className='header-text'>Date: </Text>
                  <Text className='header-text'>
                    {quotationData?.quotation_date
                      ? dayjs(quotationData.quotation_date).format('DD-MM-YYYY')
                      : 'N/A'}
                  </Text>
                </div>
                <div>
                  <Text strong className='header-text'>Die Quotation No: </Text>
                  <Text className='header-text'>{quotationData?.die_quotation_no || 'N/A'}</Text>
                </div>
              </div>
            </Col>

            <Col span={14}>
              <div className="customer-details">
                <div className="customer-details-header">Ship To</div>
                <div className="customer-details-content">
                  <Text className='header-text'>
                    {quotationData?.customer?.customer_name}
                    <br />
                    {quotationData?.customer?.factory_address?.shop},{' '}
                    {quotationData?.customer?.factory_address?.area},{' '}
                    {quotationData?.customer?.factory_address?.landmark}{' '}
                    {quotationData?.customer?.factory_address?.city}{' '}
                    {quotationData?.customer?.factory_address?.state} -{' '}
                    {quotationData?.customer?.factory_address?.pin_code}
                  </Text>
                </div>
              </div>
            </Col>

            <Col span={10}>
              <div className="customer-details" style={{ textAlign: 'right' }}>
                <div className="customer-details-header">Kind Attention</div>
                <div className="customer-details-content">
                  <Text className='header-text'>
                    {quotationData?.customer?.contact_persons?.[0]?.contact_person_name || 'N/A'}
                    <br />
                    {quotationData?.customer?.contact_persons?.[0]?.contact_person_mobile_number
                      ? `+${quotationData.customer.contact_persons[0].contact_person_mobile_number}`
                      : 'N/A'}
                  </Text>
                </div>
              </div>
            </Col>
          </Row>

          <div style={{ width: '100%', marginBottom: '10px' }}>
            <Table
              style={{ width: '100%', tableLayout: 'fixed' }}
              bordered
              size="small"
              dataSource={quotationData?.die_quotation_details || []}
              columns={columns}
              pagination={false}
              rowKey="id"
              scroll={false}
              summary={(pageData) => {
                return (
                  <>
                    <Table.Summary.Row>
                      <Table.Summary.Cell index={0} colSpan={5} className="summary-cell-center">
                        <b>Total :</b>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={1} className="summary-cell-center">
                        <b>{quotationData?.summary?.total_pieces || ''} </b>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={2} className="summary-cell-center">
                        <b>{quotationData?.summary?.total_net_weight || ''} </b>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={3} className="summary-cell-center">
                        <b>{quotationData?.summary?.total_quantity || 0}</b>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={4} className="summary-cell-right">
                        <b>{quotationData?.summary?.total_basic_amount?.toFixed(2) || '0.00'}</b>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={6} className="summary-cell-right">
                        <b>{(quotationData?.summary?.total_basic_amount * 0.18)?.toFixed(2) || '0.00'}</b>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={8} className="summary-cell-right" style={{ backgroundColor: '#f0f0f0' }}>
                        <b>
                          {(
                            (quotationData?.summary?.total_basic_amount || 0) +
                            (quotationData?.summary?.total_basic_amount || 0) * 0.18
                          )?.toFixed(2)}
                        </b>
                      </Table.Summary.Cell>
                    </Table.Summary.Row>
                  </>
                );
              }}
            />
          </div>

          <Row justify="end" gutter={[4, 4]}>
            <Col md={24}>
              <div className="bankDetails" style={{ fontSize: '12px', color: 'black' }}>
                <Text strong style={{ fontSize: '12px', fontWeight: 'bold', }}>Bank Details</Text>
                <div style={{ marginTop: 4, lineHeight: 1.6 }}>
                  <div>
                    <b>Name:</b> {settingData?.financial_settings?.bank_name}<br />
                    <b>Branch:</b> {settingData?.financial_settings?.bank_address}
                  </div>
                  <div>
                    <b>A/C:</b> {settingData?.financial_settings?.account_number}&nbsp;
                    <b>IFSC:</b> {settingData?.financial_settings?.ifsc_code}
                  </div>
                </div>
              </div>
            </Col>
          </Row>


          <div className="signature-section">
            <Row justify="space-around" align="middle" style={{ textAlign: 'center' }}>
              <Col md={12}>
                <Title level={5} style={{ color: '#12406a', margin: '5px 0', marginTop: '60px' }}>
                  Prepared By
                </Title>
              </Col>
              <Col md={12}>
                <Title level={5} style={{ color: '#12406a', margin: '5px 0', marginTop: '60px' }}>
                  Authorised Signatory
                  <br />
                  ({settingData?.company_settings?.company_name})
                </Title>
              </Col>
            </Row>
          </div>
        </div>
      </div >

      <div className="terms-page page " style={{ margin: '20px' }}>
        <Row justify="center">
          <Title level={5} style={{ color: '#12406a', margin: '5px 0 8px 0', fontSize: '16px', fontWeight: '700' }} className='terms-heading'>
            Terms & Conditions
          </Title>
        </Row>
        <Row>
          <Col span={24}>
            <div
              className="terms__content"
              dangerouslySetInnerHTML={{
                __html:
                  quotationData?.terms_and_condition
                    ?.replace(/<p>(&nbsp;|\s)*<\/p>/gi, '')
                    .replace(/\s+/g, ' ')
                    .trim() || 'Terms and conditions not available',
              }}
            ></div>
          </Col>
        </Row>
      </div>

      <div className="no-print" style={{ textAlign: 'center', marginTop: '20px', padding: '0 15px' }}>
        <Button type="primary" onClick={handlePrint} icon={<PrintIcon />}>
          Print
        </Button>
      </div>
    </>
  );
};

export default PrintDiequotation;